export const uuidRegexString = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';

export default function containsUuid(id: string) {
  const uuidRegex = new RegExp(uuidRegexString);

  return uuidRegex.test(id);
}
